import { RiShakeHandsFill, RiShakeHandsLine } from '@remixicon/react'
import { Perm_Customer_View } from '../../app/hooks/premissionScreen'
import { createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'

const icons = {
  RiShakeHandsLine,
  RiShakeHandsFill
}

export const customerMenuItem: MenuItem = createItem({
  id: 'list-customer',
  title: 'Khách hàng',
  url: `/${ROUTES.CUSTOMER}/${ROUTES.INDEX}`,
  icon: icons.RiShakeHandsLine,
  iconActive: icons.RiShakeHandsFill,
  premissions: Perm_Customer_View
})
